import { Tooltip } from '~/components';
import { useHoursFormat, usePercentFormat } from '~/hooks';
import _ from 'lodash';
import pluralize from 'pluralize';
import React from 'react';

export default function ForecastedBudgetHoursTooltip({ value, children }) {
  const percentFormat = usePercentFormat();

  const hoursFormat = useHoursFormat({ minimumFractionDigits: 0, maximumFractionDigits: 2 });

  if (!_.isNumber(value.percent)) return children;

  const difference = Math.abs(value.difference);
  const percent = percentFormat.format(Math.abs(value.percent - 1));

  let message;
  if (value.percent === 1) message = 'On budget.';
  else if (value.percent > 1) {
    message = `${hoursFormat.format(value.left)} remaining planned (estimate to complete) ${pluralize('hour', _.round(value.left, 2))} which is ${hoursFormat.format(difference)} ${pluralize('hour', _.round(difference, 2))} (${percent}) over budget.`;
  } else if (value.percent < 1) {
    message = `${hoursFormat.format(value.left)} remaining planned (estimate to complete) ${pluralize('hour', _.round(value.left, 2))} which is ${hoursFormat.format(difference)} ${pluralize('hour', _.round(difference, 2))} (${percent}) under budget.`;
  }

  return (
    <Tooltip placement="top" message={message}>
      {children}
    </Tooltip>
  );
}
